// extracted by mini-css-extract-plugin
export var modalContent = "Modal-module__modalContent___wIVRf";
export var modalOverlay = "Modal-module__modalOverlay___6abBe";
export var modalWrapper = "Modal-module__modalWrapper___dFncU";